module.exports = __webpack_public_path__ + "public/images/theater.cb142d783c2527ee086fdd77267edb7a.jpg";